import React from 'react';
import { Store, UserRound, Calendar, Clock } from 'lucide-react';
import { StatusTag } from '../../common';
import { t } from '../../../company/labels';

/** Key fact with a quiet icon chip (store, auditor, date). */
function Fact({ icon, label, value }) {
    return (
        <div className="flex items-center gap-3 min-w-0">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-100 text-[15px] text-surface-500">{icon}</span>
            <div className="min-w-0">
                <span className="block text-xs text-surface-500">{label}</span>
                <span className="block truncate text-sm font-medium text-surface-900">{value}</span>
            </div>
        </div>
    );
}

function StoreCheckTitle({ storeCheck, date, store }) {
    const duration = storeCheck?.duration || 0;
    const isPromotor = storeCheck?.user?.userType === 'promotor';

    return (
        <section className="shelf-card">
            {/* Header */}
            <div className="px-5 pt-5 pb-4">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <StatusTag tone="neutral">Auditoría</StatusTag>
                    <StatusTag tone={isPromotor ? 'success' : 'warning'} dot>
                        {isPromotor ? t('promotor') : 'Asesor'}
                    </StatusTag>
                    {duration > 0 && (
                        <StatusTag tone={duration > 30 ? 'warning' : 'neutral'} icon={<Clock />} className="tabular-nums">
                            {duration} min
                        </StatusTag>
                    )}
                </div>
                <h2 className="m-0 text-xl font-semibold tracking-tight text-surface-900">Auditoría {date}</h2>
            </div>

            {/* Info grid */}
            <div className="grid gap-4 grid-cols-1 md:grid-cols-3 px-5 py-4 border-t border-surface-100">
                <Fact icon={<Store />} label="Piso de Venta" value={store?.name || 'Sin especificar'} />
                <Fact icon={<UserRound />} label="Realizada por" value={storeCheck?.user?.name || 'Sin especificar'} />
                <Fact icon={<Calendar />} label="Fecha" value={date || 'Sin especificar'} />
            </div>
        </section>
    );
}

export default StoreCheckTitle;
